export const ESG_THEMATICS_TYPE = [
  { id: 'GREEN', displayValue: 'Green' },
  { id: 'SOCIAL', displayValue: 'Social' },
  { id: 'GOVERNANCE', displayValue: 'Governance' },
];
